/*
 * Copyright (c) 2014-2023 Comparatio
 */

import {Component, HostListener, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {AuthService} from '../auth.service';
import {UserService} from '../../services/user.service';
import {Router} from '@angular/router';
import {NgxPermissionsService} from 'ngx-permissions';
import {environment} from '../../../environments/environment';
import {versionInfo} from '../../version-info';
import {Title} from '@angular/platform-browser';
import {ScreenSizeService} from '../../services/screen-size.service';
import {MOesWorkspaceService} from '../../modules/mobile/services/m-oes-workspace.service';
import {MasterCustomerService} from '../../views/oes/services/master-customer.service';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
    companyName = 'Comparatio';
    companyLogo = '/img/comparatiologo.png';

    loginData = {};

    public loading: boolean;
    public error: string;
    public versionLabel: string;

    public isMobileScreen: boolean;
    public displayScreenToggle: boolean;
    public orientationError: boolean;
    private screenSizeService: ScreenSizeService;
    private mobileWorkspaceService: MOesWorkspaceService;

    public username: string;
    public password: string;

    constructor(
        private authService: AuthService,
        private userService: UserService,
        private permissionsService: NgxPermissionsService,
        private masterCustomerService: MasterCustomerService,
        private router: Router,
        private title: Title
    ) {

        this.title.setTitle(this.companyName + ' Portal - Login');
    }

    ngOnInit() {
        this.screenSizeService = ScreenSizeService.getInstance();
        this.isMobileScreen = (window.screen.width <= ScreenSizeService.MOBILE_SCREEN_WIDTH);
        this.displayScreenToggle = (window.screen.width <= ScreenSizeService.MOBILE_SCREEN_WIDTH);
        this.broadcastScreenSize();

        this.mobileWorkspaceService = MOesWorkspaceService.getInstance();

        this.username = null;
        this.password = null;

        this.onOrientationChange();

        if (environment.production) {
            this.versionLabel = versionInfo.number;
        } else {
            this.versionLabel = 'Test - ' + versionInfo.number;
        }

        if ( this.authService.isAuthenticated ) {
            this.goToDashboard();
        }

        this.loading = false;
        this.error   = '';

        this.authService.getLogo().subscribe(result => {
            this.companyLogo = result.logo;
            this.companyName = result.name;
            this.title.setTitle(this.companyName + ' Portal - Login');
        });
    }

    onSignUp(form: NgForm) {
        this.loading = true;

        const username = form.value.username;
        const password = form.value.password;
        this.loginData['username'] = username;
        this.loginData['password'] = password;

        this.userService.loginUser(this.loginData).subscribe(result => {
            if (result.token) {
                this.authService.authenticate(result);
                this.masterCustomerService.getById( result.oesCustomerId ).subscribe(masterCustomerResult => {
                    if (masterCustomerResult.success) {
                        const allowInventoryManagement = Number(masterCustomerResult.data.CU0_ALLOW_INVENTORY_MANAGEMENT) === 1;
                        this.mobileWorkspaceService.setInventoryManagement( allowInventoryManagement );
                    }
                });

                const DASHBOARD_READ_PERMISSION      = this.permissionsService.getPermission('DASHBOARD_READ');
                const PURCHASE_ORDER_READ_PERMISSION = this.permissionsService.getPermission('PURCHASE_ORDER_READ');

                if (DASHBOARD_READ_PERMISSION) {
                    this.goToDashboard();
                } else if (PURCHASE_ORDER_READ_PERMISSION) {
                    this.router.navigateByUrl('order-headers');
                }
            } else {
                this.loading = false;
                this.error   = result.error;
            }
        }, () => {
            this.loading = false;
        });
    }

    private broadcastScreenSize(): void {
        setTimeout(() => {
            if (this.isMobileScreen) {
                this.screenSizeService.setMobileLayout();
            } else {
                this.screenSizeService.setDesktopLayout();
            }
        }, 100);
    }

    private goToDashboard() {
        this.router.navigate([(this.isMobileScreen ? '/mobile' : '') + '/dashboard']);
    }

    onToggleLayout() {
        this.loading = true;
        this.isMobileScreen = !this.isMobileScreen;
        this.broadcastScreenSize();
        setTimeout(() => {
            this.loading = false;
        }, 500);
    }

    @HostListener('window:resize')
    onResize() {
        this.displayScreenToggle = (window.screen.width <= ScreenSizeService.MOBILE_SCREEN_WIDTH);
        if (!this.displayScreenToggle) {
            this.isMobileScreen = false;
        }
        this.broadcastScreenSize();
    }

    @HostListener('window:orientationchange')
    onOrientationChange() {
        const screen: any = window.screen;
        const angle = (screen.orientation !== undefined && screen.orientation !== null) ? Number(screen.orientation.angle) : 0;
        this.orientationError = (angle === 90 || angle === 270);
    }


}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/auth/signup/signup.component.ts